import { putJSON } from 'api/fetch';

import {
  accountNumberPublicKey,
  routingNumberPublicKey,
} from 'features/employeeOnboarding/constants';
import { TAX_ENTRY_PAYMENT_METHOD_PATH } from 'features/team/constants';

import { encryptWithPublicKey } from 'util/encryption';
import { toI18n } from 'util/i18n';

export default (formData, values) => {
  if (
    values.payment_method ===
    toI18n(`${TAX_ENTRY_PAYMENT_METHOD_PATH}.paper_check`)
  ) {
    return Promise.resolve(formData);
  }

  const payload = {
    encrypted_routing_number: encryptWithPublicKey(
      routingNumberPublicKey(),
      values.decrypted_routing_number
    ),
    encrypted_account_number: encryptWithPublicKey(
      accountNumberPublicKey(),
      values.decrypted_account_number
    ),
    subtype: values.bank_account_type,
  };

  return putJSON(`/employees/${formData.id}/update_banking_information.json`, {
    bank_account: payload,
  });
};
